import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import addMiddleWares from './middleware'
import authentication from './authentication'

const Sign = () => import('@/views/sign/sign.vue')

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: { name: 'sign' },
  },
  {
    path: '/makeSeal',
    name: 'makeSeal',
    component: () => import('@/views/makeSeal/makeSeal.vue'),
    meta: {
      title: '制作签章',
      model: 'pc',
    },
  },
  {
    path: '/sign',
    name: 'sign',
    component: Sign,
    meta: {
      title: '文件签署',
    },
  },
  {
    path: '/addSignNamePage',
    name: 'addSignNamePage',
    component: () => import('@/views/sign/addSignNamePage.vue'),
    meta: {
      title: '文件签署',
    },
  },
  ...authentication,
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
})

addMiddleWares({ router, store })
VueRouter.prototype.goBack = function() {
  this.isBack = true
  this.go(-1)
}

export default router
